"use strict";

/* Constants */
const storeLocatorData = $(".js-states-and-cities-json");
const stateAndCityList = storeLocatorData.data("state-and-city-list");
const defaultState     = storeLocatorData.data("default-state") || "";
const defaultCity      = storeLocatorData.data("default-city")  || "";

/**
* Returns the list of cities for a given state
* @param {Object} $stateDropdown - jQuery object of the state dropdown
* @returns {Array} - an array of cities for the given state
*/
function getCityList($stateDropdown) {
    var $selectedState   = $stateDropdown.find("option:selected");

    return stateAndCityList[$selectedState.val().toString()];
}

/**
* Populates the city dropdown with the list of cities
* @param {Array} cityList - List of cities
* @param {Object} $cityDropdown - jQuery object of the city dropdown
* @param {String} defaultCity - Default city to be selected
*/
function populateCityDropdown(cityList, $cityDropdown, defaultCity) {
    for (var city of cityList) {
        var cityOptionHtml = `<option value="${city}" ${city === defaultCity ? "selected" : ""}>${city}</option>`;

        $cityDropdown.append(cityOptionHtml);
    }
}

module.exports = {
    /**
    * Event handler for when the state dropdown is changed
    * @param {Object} $container - jQuery object of the store locator container
    * @param {Object} $stateDropdown - jQuery object of the state dropdown
    * @param {Object} $citiesDropdown - jQuery object of the cities dropdown
    * @param {Object} $citiesDropdownOptions - jQuery object of the cities dropdown options
    * @param {Array} cityList - array of cities
    */
    updateCitiesDropdownOnStateSelection : function () {
        $(document).on("change", ".js-current-state", function (e, defaultCity) {
            var $container             = $(".store-locator-container");
            var $stateDropdown         = $(this, $container);
            var $citiesDropdown        = $(".js-dropdown-cities", $container);
            var $citiesDropdownOptions = $citiesDropdown.find("option");
            var cityList               = getCityList($stateDropdown);

            $citiesDropdownOptions.not(":first").remove();

            if (cityList) {
                populateCityDropdown(cityList, $citiesDropdown, defaultCity);
            }

            $citiesDropdown.trigger("change");
        });
    },

    /**
    * Sets the default state and city for the store locator
    * @param {string} defaultState - the default state
    * @param {string} defaultCity - the default city
    */
    initDefaultStateAndCity : function () {
        if (defaultState && defaultCity) {
            $(".js-current-state")
                .val(defaultState)
                .trigger("change", [defaultCity]);
        }
    },
};
